module.exports = __webpack_public_path__ + "img/desktop.198bbafe.png";